import * as React from 'react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/nb'

dayjs.extend(relativeTime)

const Date = ({ children, relative, withTime }: Props) => {
  if (!children) return <></>
  let date: string | number
  // Dates from 3rd parties might not be timestamps
  if (
    children.includes('.') ||
    children.includes(':') ||
    children.includes('-')
  ) {
    date = children
  } else {
    date = Number(children)
  }
  if (relative) return <>{dayjs(date).locale('nb').fromNow()}</>
  if (withTime)
    return <>{dayjs(date).locale('nb').format('DD.MM.YYYY – hh.mm')}</>
  return <>{dayjs(date).locale('nb').format('DD.MM.YYYY')}</>
}

type Props = {
  children: string
  relative?: boolean
  withTime?: boolean
}

export default Date
